<template>
  <div class="content" :class="{active}">
   <div class="image" :style="style">
      <span v-if="legend">{{ legend }}</span>
      <img 
      refs="img"
      :src="src"
      :srcset="srcset"
      :alt="alt">
   </div>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'DisplayImage',
  props: {
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    legend: {
      type: [String, Boolean],
      default: false,
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const getRandom = (min, max) => (Math.random() * (max - min) + min).toFixed(2)

    const style = computed(() => {
      const limit = window.innerWidth > 768 ? 60 : window.innerWidth > 450 ? 40 : 20
      return {
        marginLeft:`${getRandom(0, limit)}%`
      }
    })

    return {
      style
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    opacity: 0;
    transition: opacity 800ms 2s $ease-out;
    margin: 8rem 0;

    &.active {
      opacity: 1;
    }
  }

  .image {
    position: relative;
    pointer-events: none;
    display: inline-block;
    width: 40%;

    span {
      @extend %font-regular;

      display: inline-block;
      position: absolute;
      white-space: nowrap;
      top: 0.4rem;
      left: calc(100% + 0.8rem);
      font-size: 0.4rem;
      line-height: 0.6rem;
      letter-spacing: 0.2rem;
      transform: rotate(90deg);
      transform-origin: top left;
    }

    img {
      width: 100%;
      display: block;
      box-shadow: -4px 4px 15px 4px rgba($black, 0.15);
    }

    @media screen and (max-width: $tablet) {
      width: 60%;
    }

    @media screen and (max-width: $mobile) {
      width: 80%;
    }
  }
</style>